// extracted by mini-css-extract-plugin
export default {"input":"AddSubjectForm_input__gPdp1"};